/**
 * NexoPagosApiClient -- HTTP client for /api/v1/nexo-pagos.
 * Pagos de suscripcion Nexo Digital (control de cobros de Nexo).
 * Solo admin (RequireAdmin en API): es la caja de Nexo.
 *
 * Mission: NEXO-VENTAS-SUSCRIPCIONES-V1-001 (NX-T2)
 * @module infrastructure/api/NexoPagosApiClient
 */

import { ApiBase } from './ApiBase.js';

const BASE = '/api/v1/nexo-pagos';

export const NexoPagosApiClient = {
  /**
   * Lista pagos + resumen. Sin mes: todos los pagos + resumen historico.
   * @param {string} [mes] - mes_cubierto formato YYYY-MM
   */
  async list(mes) {
    const qs = mes ? `?mes=${encodeURIComponent(mes)}` : '';
    return ApiBase.get(`${BASE}${qs}`);
  },

  /**
   * Alta manual de pago de suscripcion.
   * @param {object} pago - { businessId, negocioNombre, monto, medio, fechaPago, mesCubierto, canalActivacion, notas }
   */
  async create(pago) {
    return ApiBase.post(BASE, pago);
  },

  /**
   * Registra el pago y deja la suscripcion activa hasta el fin del mes cubierto, en una accion
   * (PAGOS-NEXO-ACTIVAR-API-T1, de A). Mientras la ruta no este publicada responde 404/405 y no
   * se registra nada: la vista lo dice y el boton viejo sigue.
   * @param {object} pago - { businessId, monto, medio, fechaPago, mesCubierto, notas, tarifa, descuento, motivoDescuento }
   */
  async registrarYActivar(pago) {
    return ApiBase.post(`${BASE}/registrar-y-activar`, pago);
  },

  /**
   * La cartera: por negocio, los meses en deuda desde 2026-08, y los pagos sin negocio con su candidato
   * (PAGOS-NEXO-CARTERA-API-T1, nexo-api PR 455). La lee application/negocios/carteraNexo.js.
   */
  async cartera() {
    return ApiBase.get(`${BASE}/cartera`);
  },

  /**
   * Asigna un pago que quedo sin negocio (solo esos: no reasigna). 422 PAGO_* si la base no lo deja.
   * @param {string} id - id del pago (uuid)
   * @param {object} cuerpo - { businessId }, armado por cuerpoAsignar
   */
  async asignarNegocio(id, cuerpo) {
    return ApiBase.post(`${BASE}/${encodeURIComponent(id)}/negocio`, cuerpo);
  }
};
